import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Settings } from './../../_models/settings/settings.model';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


import { AlertService, DialogCloseService, StorageServiceProvider } from '../../_services/services';
import { UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { LocationServiceProvider } from '../../_services/location.service';

import { Title } from '@angular/platform-browser';
import { ServiceLocator } from '../../locater.service';
import { NameIdTypesComponent } from '../shared/name-id-types/name-id-types.component';
import { Global } from 'src/app/globals';
import utils from './../../utils';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { StorageKeys } from 'src/app/_constants';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';



@Component({
    templateUrl: 'settings.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ],
})

export class SettingsComponent implements OnInit {
    locationAutocomplete: UntypedFormControl;
    showSpinner: boolean = false;
    resultfetched: boolean = false;
    filteredLocations: Observable<any[]>;

    settings: Settings;
    settingsResult: Settings[] = [];
    locations: any[];
    returnUrl: '';

    isLinear = false;
    firstFormGroup: UntypedFormGroup;
    secondFormGroup: UntypedFormGroup;
    changeNameIdTypeText: string;
    myControl = new UntypedFormControl();
    options: string[] = ['1 - One', '2 - Two', '3 - Three'];
    filteredOptions: Observable<string[]>;
    nameIdTypes: string[];
    constructor(
        private route: ActivatedRoute,
        private formBuilder: UntypedFormBuilder,
        public globals: Global,
        private alertService: AlertService,
        private router: Router,
        locationService: LocationServiceProvider, private titleService: Title,
        private closeDialogService: DialogCloseService,
        private storage: StorageServiceProvider,
        private blockUI: LoadingService,
        private dialog: MatDialog) {
        // this.titleService.setTitle("Settings");
        this.blockUI.start();
        this.settings = this.storage.get(StorageKeys.Settings) || new Settings();
        this.settings.quotesExpiryDays = this.settings.quotesExpiryDays != null ? this.settings.quotesExpiryDays : 5;
        this.locationAutocomplete = new UntypedFormControl();
        this.settings.locationCode = utils.getLocation();
        if (this.settings.endNameIdType == undefined) {
            this.settings.endNameIdType = '';
        }
        if (this.settings.startNameIdType == undefined) {
            this.settings.startNameIdType = '';
        }
        this.settings.ccEmail = utils.getccEmail();
        this.settings.numberOfCustomersInSearchResult = this.settings.numberOfCustomersInSearchResult ? this.settings.numberOfCustomersInSearchResult : 30;
        this.settings.numberOfItemsInSearchResult = this.settings.numberOfItemsInSearchResult ? this.settings.numberOfItemsInSearchResult : 30;

        this.settings.showQuantityOfAllLocations = utils.getShowQuantityOfAllLocations();
        this.settings.disableQuotesExpiry = this.settings.disableQuotesExpiry;
        this.locationAutocomplete.setValue(this.settings.locationCode);
        if (!this.settings.startNameIdType) {
            this.changeNameIdTypeText = "Select Name Id Type Range ";
        }
        else {
            this.changeNameIdTypeText = "Name Id Type Range - (" + this.settings.startNameIdType + " to " + (this.settings.endNameIdType ? this.settings.endNameIdType + ")" : '*)');
        }
        locationService.syncLocations((locations) => {
            this.locations = locations;
            this.blockUI.stop();
        });;
    }
    ngOnInit() {

        this.returnUrl = this.route.snapshot.queryParams['LocationCode'] || 'true';
        if (this.returnUrl.toLocaleLowerCase() === 'false') {
            this.alertService.warning("Location Code is empty");
        }

        this.firstFormGroup = this.formBuilder.group({
            firstCtrl: ['', Validators.required]
        });
        this.secondFormGroup = this.formBuilder.group({
            secondCtrl: ['', Validators.required]
        });
        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }
    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }
    saveSettings() {
        if (this.settings.locationCode == undefined) {

            this.alertService.error("Select code from list", false, true);
            return;
        }

        var locationItem = this.locations.find(x => x.code == this.locationAutocomplete.value);
        if (locationItem == undefined) {
            this.alertService.error("Select code from list", false, true);
            return;
        }
        // if (this.settingsResult.length != 0 && locationItem == undefined) {
        //     this.alertService.error("Select code from list2", false, true);

        //     return;
        // }

        utils.saveSettings(this.settings);

        this.router.navigate(['/home']);
    }
    validateTransaction() {

        if (
            this.settings.locationCode == '' //||
        ) {
            return false;
        }
        else {
            return true;
        }
    }


    searchText() {

        if (this.locationAutocomplete.value == '') {
            this.settings.locationCode = '';
        }

        if (!this.resultfetched) {
            this.showSpinner = true;
            this.blockUI.start();
            this.onSearchResponds(this.locations);
        }
    }
    onSearchResponds = (response: any) => {
        this.showSpinner = false;

        if (response.length == 0) {
            this.settingsResult = null;
            this.alertService.warning('No records found.', false, true);
            this.blockUI.stop();
        } else {
            this.resultfetched = true;
            this.blockUI.stop();
            this.settingsResult = <Settings[]>response;

            this.filteredLocations = this.locationAutocomplete.valueChanges
                .pipe(
                    startWith(''),
                    map(loc => loc ? this.filterLocation(loc) : this.settingResultSlice(this.settingsResult))
                );

        }
    }

    filterLocation(locationCode: string) {
        return this.settingsResult.filter(loc =>
            loc.code.includes(locationCode));
    }
    settingResultSlice(settingsResult) {
        return settingsResult && settingsResult.length ? settingsResult.slice() : '';
        // return settingsResult ? settingsResult.slice() : '';
    }
    getitem(event: MatOptionSelectionChange, settings: any) {

        if (event.source.selected) {
            this.settings.locationCode = settings.code;

            this.locationAutocomplete.setValue(settings.code);
            this.settings.LocationCodeDv = settings.description
        }
    }

    clearFields() {
        this.settings.url = '';
        this.settings.profileName = '';
        this.settings.userId = '';
        this.settings.code = '';
        this.settings.types = '';
        this.settings.dataSetNo = '';
        this.settings.password = '';
        this.settings.locationCode = '';
        this.settings.startNameIdType = '';
        this.settings.endNameIdType = '';
        this.settings.numberOfCustomersInSearchResult = 30;
        this.settings.numberOfItemsInSearchResult = 30;
        this.settings.showQuantityOfAllLocations = false;
        this.locationAutocomplete.setValue('');
    }
    onChange(e: Event) {
    }

    onFocus($event) {
        var topContainer = document.getElementById("topContainer");

        if (topContainer) {
            topContainer.style.display = "none";
        } else {
            console.log("topContainer does not exist!");
        }
    }
    onBlur($event) {
        var topContainer = document.getElementById("topContainer");

        if (topContainer) {
            topContainer.style.display = "block";
        } else {
            console.log("topContainer does not exist!");
        }
    }

    openNameIdTypeDialog() {
        let dialogRef = this.dialog.open(NameIdTypesComponent,
            {
                data: {
                    startNameIdType: this.settings.startNameIdType,
                    endNameIdType: this.settings.endNameIdType
                },
                width: '500px',
            });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result) {
                this.settings.startNameIdType = result.startNameIdType;
                this.settings.endNameIdType = result.endNameIdType;
                if (!this.settings.startNameIdType) {
                    this.changeNameIdTypeText = "Select Name Id Type Range ";
                }
                else {
                    this.changeNameIdTypeText = "Name Id Type Range - (" + this.settings.startNameIdType + " to " + (this.settings.endNameIdType ? this.settings.endNameIdType + ")" : '*)');
                }
            }
        });
        this.closeDialogService.emitRegisterDialog(dialogRef);
    }

}



